module.exports = __webpack_public_path__ + "img/home_blue.d7a1a4c9.svg";